export default {
  path: '/2019MemorialDay',
  name: '2019MemorialDay',
  component: () => import('./Home.vue'),
  // redirect: '/2019GoAheadChina/ListPage',
  meta: {
    title: '永远的丰碑，网上祭英烈',
  },
  // children: [],
};
